import './modules/jquery.js';
import './modules/bootstrap.js';
import './modules/cookies.js';
import { bindDataLayerEvents } from './modules/datalayer.js';
import './modules/add-to-cart-form.js';
import './modules/cart-updater.js';
import './modules/user.js';

bindDataLayerEvents();
